import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Home from "./pages/Home";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#121311",
              color: "#F7F6F2",
              border: "1px solid rgba(247,246,242,0.15)",
              borderRadius: 0,
              fontFamily: "'Manrope', sans-serif",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
